if(!customElements.get('tabbed-content')) {
  class TabbedContent extends HTMLElement {
    constructor() {
      super();
      
      this.elButtons = this.querySelectorAll('[data-tab-button]');
      this.elPanels = this.querySelectorAll('[data-tab-panel]');

      this.elButtons.forEach(el => {
        el.addEventListener('click', this.setActiveTab.bind(this));
      })
    }

    setActiveTab(ev) {
      ev.preventDefault();
      const { id: activeId } = ev.currentTarget;

      this.elButtons.forEach(el => {
        let isActive = el == ev.currentTarget;
        el.ariaSelected = isActive;
      });

      this.elPanels.forEach(el => {
        let isActive = el.getAttribute('aria-labelledby') == activeId;
        el.tabIndex = isActive ? 0 : -1;
      });
    }
  }

  customElements.define('tabbed-content', TabbedContent);
}